import { getSwapCreditTextContent } from '../services/questionnaire';

const swapCreditModalContentQuery = {
  key: 'sanityList',
  query: getSwapCreditTextContent,
};

export { swapCreditModalContentQuery };
